import React from "react";
import { BUSINESS_INFO } from "../../constants/businessInfo";

const CompanyInformation = ({ compact = false, dark = false, className = "" }) => {
  const labelClass = dark ? "text-slate-300" : "text-slate-500";
  const valueClass = dark ? "text-slate-100" : "text-slate-700";
  const cardClass = dark
    ? "border-slate-700 bg-slate-900/70"
    : "border-slate-200 bg-white";

  return (
    <section
      className={`rounded-2xl border p-6 shadow-sm ${cardClass} ${className}`}
      aria-label="Company Information"
    >
      <h2 className={`text-xl font-semibold ${dark ? "text-white" : "text-slate-900"}`}>
        Company Information
      </h2>

      <div className={`mt-4 grid gap-4 ${compact ? "sm:grid-cols-2" : "sm:grid-cols-1"}`}>
        <InfoRow label="Company Name" value={BUSINESS_INFO.companyName} labelClass={labelClass} valueClass={valueClass} />
        <InfoRow
          label="Company Registration Number"
          value={BUSINESS_INFO.registrationNumber}
          labelClass={labelClass}
          valueClass={valueClass}
        />
        <InfoRow label="GST Number" value={BUSINESS_INFO.gstNumber} labelClass={labelClass} valueClass={valueClass} />

        <div>
          <p className={`text-sm font-medium ${labelClass}`}>Office Address</p>
          <address className={`mt-1 not-italic text-sm leading-6 ${valueClass}`}>
            {BUSINESS_INFO.officeAddressLine1}
            <br />
            {BUSINESS_INFO.officeAddressLine2}
            <br />
            {BUSINESS_INFO.city}, {BUSINESS_INFO.state} - {BUSINESS_INFO.pinCode}
          </address>
        </div>

        <InfoRow
          label="Business Email"
          value={
            <a
              href={`mailto:${BUSINESS_INFO.businessEmail}`}
              className="text-blue-600 hover:text-blue-500 hover:underline"
            >
              {BUSINESS_INFO.businessEmail}
            </a>
          }
          labelClass={labelClass}
          valueClass={valueClass}
        />

        <InfoRow
          label="Phone Number"
          value={
            <a
              href={`tel:${BUSINESS_INFO.phone.replace(/\s+/g, "")}`}
              className="text-blue-600 hover:text-blue-500 hover:underline"
            >
              {BUSINESS_INFO.phone}
            </a>
          }
          labelClass={labelClass}
          valueClass={valueClass}
        />

        <InfoRow label="Office Timings" value={BUSINESS_INFO.officeTimings} labelClass={labelClass} valueClass={valueClass} />
      </div>
    </section>
  );
};

const InfoRow = ({ label, value, labelClass, valueClass }) => (
  <div>
    <p className={`text-sm font-medium ${labelClass}`}>{label}</p>
    <div className={`mt-1 text-sm ${valueClass}`}>{value}</div>
  </div>
);

export default CompanyInformation;
